import { Box } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { useContext } from "react";
import { DataDescriptor } from "../../context/DataDescriptor";
import styles from "../../css/Timeline.module.css";

export const Timeline = () => {
  const { waveformLoaded, percent, segmentsProgress, loadingWave } = useContext(DataDescriptor);
  
  const displayProgress = segmentsProgress > 0 ? segmentsProgress : percent;
  const progressLabel = segmentsProgress > 0 ? "loading segments" : "loading audio";
  
  return (
    <div className={styles.container_timeline}>
      {(!waveformLoaded || loadingWave) && (
        <Box sx={{ display: "flex", width: "100%", justifyContent: "center", alignItems: "center", flexDirection: "column", gap: 1 }} >
          {" "}
          <p role="progressbar" aria-valuenow={displayProgress} aria-live="polite" aria-label={displayProgress < 100 ? "Loading Project" : "Project Successfully Loaded!"} autoFocus></p>
          {loadingWave &&  <div className='loader'></div>}
          {!waveformLoaded && (
            <>
              <CircularProgress />
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "4px" }}>
                <div style={{ fontSize: "18px", fontWeight: "bold" }}>{displayProgress}%</div>
                <div style={{ fontSize: "12px", color: "#999" }}>{progressLabel}</div>
              </div>
            </>
          )}
        </Box>
      )}
      <div
        id="waveform-timeline"
        className={styles.timeline_row}
        style={{ visibility: `${(waveformLoaded && !loadingWave) ? "visible" : "hidden"}` }}
      ></div>
      {" "}
      <div
        id="waveform"
        style={{ visibility: `${(waveformLoaded && !loadingWave) ? "visible" : "hidden"}` }}
      ></div>
    </div>
  );
};
